'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _catalogueResults = require('./components/catalogue-results');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogueResults).default;
  }
});

var _bibItemInfo = require('./components/bib-item-info');

Object.defineProperty(exports, 'BibItemInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bibItemInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-results/index.js
// module id = 982
// module chunks = 1